export default __webpack_public_path__ + "6f46d9ec64aab56fc6f24f36d32ee707.webp";